import HospitalHeaderDTO from '@src/adapters/dto/hospital/HospitalHeaderDTO';
import useCachedList from './CachedList';
import useAuthorisedHospitalsLazy from '@src/adapters/hooks/hospital/useAuthorisedHospitals';

const AuthorisedHospitalList = () => {
  return useCachedList<HospitalHeaderDTO>(
    'hospitalList',
    useAuthorisedHospitalsLazy
  );
};

export default AuthorisedHospitalList;
